import React, { useContext, useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch, useSelector } from "react-redux";
import "./SectionOne.css";

import "bootstrap-icons/font/bootstrap-icons.css";
import { addToList, showListing } from "../../features/listingSlice";
import NavbarComponent from "../navbar/NavbarComponent";
import { SEARCH_API } from "../../constants/Api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Button, Flex, Modal } from "antd";
import { PathContext } from "../../App";
function SectionOne() {
  const [placeHolder, setPlaceHolder] = useState(
    "Search using zip codes, City, State or property address"
  );
  const [showSearchHistory, setSearchHistory] = useState(false);
  const [query, setQuery] = useState("");
  const dispatch = useDispatch();
  const listingItems = useSelector((state) => state.listing.listingItems);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const btRef = useRef(null)

  const token = localStorage.getItem("token");
  const closePopup = localStorage.getItem("closePopup");
  const [open, setOpen] = useState(false);
  const [openResponsive, setOpenResponsive] = useState(false);
  const { path, setPath } = useContext(PathContext);
  useEffect(() => {
    if (!token) {
      if(!closePopup){
        setTimeout(() => {
          setOpenResponsive(true);
        }, 4000);
      }

    }
  }, []);

  const handleFocus = () => {
    console.log("hi");
    setPlaceHolder("");
    setSearchHistory(true);
    document.getElementById("hero-search-button").style.borderRadius =
      "0px 10px 10px 0px";
  };
  const handleClick = (link) => {
    if (link === "/user-register") {
      setPath("nav");
    }
    navigate(link);
  };
  const handleSearchClick = async () => {
    if (!query.trim()) {
      toast.error("Please enter a valid query.");
      return;
    }
    setSearchHistory(false);
    setLoading(true);
    try {
      const response = await fetch(SEARCH_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query }),
      });

      const json = await response.json();
      if (response.ok) {
        if (!listingItems.includes(query.toLowerCase())) {
          dispatch(addToList(query.toLowerCase()));
        }

        // const isZipCode = /^\d{5}$/.test(query.trim());
        navigate(json.listing ? "/zipcode-listing" : "/listing-detail", {
          state: { data: json.houses, zipcode: json.listing ? query : undefined },
        });
      } else {
        toast.error(json.error || "Something went wrong. Try again.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleSectionClick = () => {
    setSearchHistory(false);
  };

  const handleHistortyClick = (newQuery) => {
    setQuery(newQuery);
    setSearchHistory(false);
  };

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [isTab, setIsTab] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsTab(window.innerWidth <= 990);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      btRef.current.click()
    }
  };
  const handleClose = () => {
    localStorage.setItem("closePopup", "closepopup")
setOpenResponsive(false)
  }
  return (
    <div className="section-one" onClick={handleSectionClick}>
      <NavbarComponent />

      <Modal
        style={{ padding: "0px", margin: "0px" }}
        centered
        open={openResponsive}
        footer={null}
        closable={false}
        width={{
          xs: "90%",
          sm: "80%",
          md: "70%",
          lg: "70%",
          xl: "65%",
          xxl: "65%",
        }}
      >
        <div className="container-fluid pop-up">
      
          <div className="row px-0 mx-0">
            <div className="col-9">
            <h2 className="deals-direct-today">Join Deal Direct Today!</h2>
            </div>
            <div className="col-3 text-end">
            <img
            src="/img/pop-up-close.svg"
            className="img-fluid pop-up-close-home"
            onClick={()=>handleClose()}
            role="button"
            alt=""
          />
            </div>
          </div>
          <div className="row px-0 mx-0">
            <div className={`col-lg-6 d-flex flex-column align-items-start justify-content-evenly ${isTab? "gap-2" : ""}`}>
          
              <button
                onClick={() => handleClick("/user-register")}
                className="pop-up-button"
                role="button"
              >
                <img src="/img/p-2.svg" className="img-fluid" alt="" />
                <span>Become a DDH Client</span>
              </button>
              <button
                onClick={() => handleClick("/agent-register")}
                className="pop-up-button"
                role="button"
              >
                <img src="/img/p-3.svg" className="img-fluid" alt="" />
                <span>Become a DDH Listing/Showing Agent</span>
              </button>
                 
              <button
                onClick={() => handleClick("/tc-register")}
                className="pop-up-button"
                role="button"
              >
                <img src="/img/p-4.svg" className="img-fluid" alt="" />
                <span>Become a DDH Transaction Coordinator</span>
              </button>
              <button
                onClick={() => handleClick("/la-register")}
                className="pop-up-button"
                role="button"
              >
                <img src="/img/p-5.svg" className="img-fluid" alt="" />
                <span>Become an LO Agent</span>
              </button>
              <button
                onClick={() => handleClick("/advertiser-register")}
                className="pop-up-button"
                role="button"
              >
                <img src="/img/p-1.svg" className="img-fluid" alt="" />
                <span>Become a DDH Service Provider {isTab}</span>
              </button>
             
       
           
            </div>
            <div className={`col-lg-6 d-flex align-items-center justify-content-center pop-up-image-section ${isTab? "d-none" : ""}`}>
              <img src="/img/pop-image.svg" className="img-fluid" alt="" />
            </div>
          </div>
        </div>
      </Modal>

      <div className="hero-content-section">
        <div className="container-fluid">
          <div className="row text-center">
            <div className="col-12 py-0">
              <span className="hero-desc-1">Buy your dream home</span>
            </div>
            <div className="col-12 py-0">
              <span className="hero-heading">PREMIERING IN CALIFORNIA</span>
            </div>
            <div className="col-12 py-0">
              <span className="hero-desc-2">And save thousands</span>
            </div>
            <div
              id="search-container"
              className={`col-12 d-flex justify-content-center ${isMobile? "px-0" : ""}`}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="row w-100">
                <div className={`col-12 d-flex justify-content-center ${isMobile? "p-0" : ""}`}>
                  <div className="input-group hero-input-group mb-3 position-relative">
                    <button className="btn hero-search-icon" type="button">
                      <img
                        src="/img/search-icon.svg"
                        className="img-fluid"
                        alt=""
                      />
                    </button>
                
                    <input
                      onFocus={handleFocus}
                      onBlur={() =>
                        setPlaceHolder("Search using zip codes, City, State or property address")
                      }
                      type="text"
                      className="form-control hero-input"
                      placeholder={placeHolder}
                      aria-label="Recipient's username"
                      aria-describedby="button-addon2"
                      onChange={(e) => setQuery(e.target.value)}
                      value={query}
                      onKeyDown={handleKeyDown} // Detect Enter key
                    />
                    {loading ? (
                      <button
                        className="btn hero-search-button"
                        type="button"
                        id="hero-search-button"
                      >
                        <span
                          className="spinner-border text-white"
                          style={{ height: "14px", width: "14px" }}
                        ></span>
                      </button>
                    ) : (
                      <button
                        onClick={handleSearchClick}
                        className="btn hero-search-button"
                        type="button"
                        id="hero-search-button"
                        ref={btRef}
                        
                      >
                        <img
                          src="/img/Vector.svg"
                          className="img-fluid"
                          alt=""
                        />
                      </button>
                    )}
                    {loading ? (
                      <div className="col-12 d-flex justify-content-start mt-2">
                        <span className="text-white collecting-data-text">
                          Collecting Data...
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}

                    {showSearchHistory && listingItems.length > 0 ? (
                      <div className="col-12 d-flex justify-content-center search-history-column">
                        <div className="search-result-group">
                          {listingItems.slice(-3).map((item, index) => (
                            <div
                              role="button"
                              onClick={() => handleHistortyClick(item)}
                              className="search-result-item w-100 text-start d-flex align-items-center gap-3"
                              key={index}
                            >
                              <i
                                className="bi bi-clock-history"
                                style={{ fontSize: "13px" }}
                              ></i>{" "}
                              {item}
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-section-footer">
        <div className="container-fluid">
          {isMobile ? (
            <>
              <div className="row py-2" style={{backgroundColor: "rgb(0 0 0 / 10%)", borderRadius: "10px"}}>
                <div className="col-12">
                  <p className="hero-section-footer-mobile-text-1 mb-0">
                    Deal Direct homes provides home buyers the opportunity to be
                    in control and <span className="bold-content-1 mx-1">NEVER</span>
                    pay realtor commission. Save thousands by
                    <span className="bold-content-1 mx-1">DEALING DIRECT.</span>
                  </p>
                  <p className="hero-section-footer-mobile-text-2">
                  Home Buying Made Simple with Deal
                  Direct Homes
                  </p>
                </div>
              </div>
            </>
          ) : (
            <div className="row py-2" style={{backgroundColor: "rgb(0 0 0 / 10%)", borderRadius: "10px"}}>
              <div className="col-md-6 d-flex align-items-center">
                <span className="hero-section-footer-text-1">
                  Deal Direct homes provides home buyers the opportunity to be
                  in <br />
                  control and <span className="bold-content-1">NEVER</span> pay
                  realtor commission. Save thousands by <br />
                  <span className="bold-content-1">DEALING DIRECT.</span>
                </span>
              </div>
              <div className="col-md-6 d-flex justify-content-md-end align-items-center">
                <span className="hero-section-footer-text text-center">
                  <span className="bold-content-1">
                    Home Buying Made Simple <br className="d-block" /> with Deal
                    Direct Homes
                  </span>
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SectionOne;
